
import HeroAreaInternal from '@/components/modules/HeroAreaInternal'
import StationCardList from '@/components/modules/StationCardList.vue';
import SectionLoader from '@/components/SectionLoader'
export default {
    components: {
        HeroAreaInternal,
        StationCardList,
        SectionLoader
    },
    scrollToTop: true,
    head() {
        return {
            title: "MOT Centers",
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: "MOT Centers"
                },
                {
                    hid: 'twitter:title',
                    property: 'twitter:title',
                    content: "MOT Centers"
                },
            ],
        }
    },
    layout: 'garage',
    data() {
        return {
            areas: null,
            stationList: null,
            loading: true,
        }
    },
    async fetch() {
        //Get the list of post data
        this.areas = await fetch(this.$config.fetchUrl + '/api/stations/getCities')
            .then(res => res.json()).catch(error => {
                console.error("There was an error!", error);
            });
            this.loading = false;
    },

    created() {
        if (process.client && navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.showLoc(position)
            })
        }

    },
    mounted(){
        window.scrollTo(0,0)
    },
    updated(){
        window.scrollTo(0,0)
    },
    methods: {
       async showLoc(pos) {
            if (pos && pos.coords) {
                this.stationList = await fetch(this.$config.fetchUrl + '/api/stations/getNearbyStations/' + pos.coords.latitude + "/" + pos.coords.longitude)
                    .then(res => res.json()).catch(error => {
                        console.error("There was an error!", error);
                    });
                    this.stationList.name = "nearby";
                    if(this.stationList && this.stationList.stations && this.stationList.stations.length > 0)
                    this.$parent.$emit("addPadding", true);
            }
        }

    }


}
